var kind    = require("enyo/kind");

require("app/ui/InputWrapper.less");

/**
 * A wrapper around app.ui.Input, allowing to easily position buttons on top of
 * it.
 */
module.exports = kind(/** @lends  app.ui.InputWrapper.prototype */ {

    /**
     * @private
     */
    name: "app.ui.InputWrapper",

    /**
     * @private
     */
    classes: "app-ui-input-wrapper"

});
